import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h11.175a1.98 1.98 0 0 1 1.4.575l2.85 2.85a1.98 1.98 0 0 1 .575 1.4V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zM19 7.85 16.15 5H5v14h14zM12 18q1.25 0 2.125-.875A2.9 2.9 0 0 0 15 15q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 12q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 15q0 1.25.875 2.125A2.9 2.9 0 0 0 12 18m-5-8h7q.424 0 .713-.287A.97.97 0 0 0 15 9V7a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 6H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 7v2q0 .424.287.713Q6.575 10 7 10M5 7.85V19 5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }